//retrict the website on IE and
var ua = window.navigator.userAgent;
var edge = ua.indexOf('Edg/');
var msie = ua.indexOf('MSIE');
var trident = ua.indexOf('Trident/');
if (msie > 0 || trident > 0 || typeof jQuery == 'undefined') {
  alert("Your browser does not support JavaScrit. Some features may not work. Please try to open link with other browser i.e Chrome, Firefox etc.");
  window.location.href = "https://solutions.springernature.com/";
}
      
// code for outbound links
$(document.links).filter(function() {
  return this.hostname != window.location.hostname;
}).attr('target', '_blank');

let show_alert = () => {
  $(".product-single__add").hide();
  alert("We could not find any data related to your URL.");
  
  // redirect to home page once alert is removed
  window.location = "/";
}

$(function(){

  let url_string = window.location.href;
  let url = new URL(url_string);
  let jb_key = url.searchParams.get("key");
  let product_id = $("#product_id").data("id");

  if(url_string.includes("products/reprints") || url_string.includes("products/poster") || url_string.includes("products/nature-poster") || url_string.includes("products/nature-reprints") || url_string.includes("products/media-kit")){
    if(jb_key !== null){

      $.ajax({
        method: "POST",
        url: `${privateAppUrl}/api/get_job_data`,
        data: {meta_key: jb_key, product_id: product_id},
        crossOrigin: true,
        success: function(data){
         console.log(data);
         // console.log((typeof data.author_address.Postcode == 'undefined')?' ':data.author_address.Postcode[0]);
        
          if(typeof data.error == "undefined" ){

            var html = "<table class='journal_table'>";

            html += "<tr><td>Journal Title: <b>"+ data.journal_title +"</b></td></tr>";

            html += "<tr><td>Article Title: <b>" + data.article_title + "</b></td></tr>";

            html += "<tr><td>Author Name: <b>" + data.author_name +"&nbsp"+data.author_lastname + "</b></td></tr>";

            html += "<tr><td>Publisher Name: <b>" + data.publisher_name + "</b></td></tr>";
            if(!url_string.includes("products/media-kit")) {
			if((data.free_offprints && $("#poster").length < 1) && (data.free_offprints && $("#nature-poster").length < 1) ){ 
              html += "<tr><td>Number of Free Offprints: <b>" + data.free_offprints + "</b></td></tr>";
            }
            }

            html += "</table>";
                window.sessionStorage.setItem("city", (data.author_address!='')?data.author_address.City[0]:'' );
                  window.sessionStorage.setItem("address",data.author_address!=''?data.author_address.Street[0]:'');
                  window.sessionStorage.setItem("zipcode", (data.author_address!='')?((typeof data.author_address.Postcode == 'undefined')?'':data.author_address.Postcode[0]):'' );
                  window.sessionStorage.setItem("country",(data.author_address!='')?data.author_address.Country[0]._:'' );
                  window.sessionStorage.setItem("firstname",(data.OffprintRecipientName!='')?data.OffprintRecipientName.GivenName[0]:'');
                  window.sessionStorage.setItem("lastname",(data.OffprintRecipientName!='')?data.OffprintRecipientName.FamilyName[0]:'');

            // set cart attribute as file name
           // var data_array = {attributes: {'job_sheet': data.sheet_name, 'free_offprints': data.free_offprints, 'url_email': data.author_email, 'journal_title': data.journal_title, 'journal_id': data.journal_id, 'article_id':data.article_id, 'article_DOI':data.article_DOI}, note:data.journal_title}
           // console.log(data_array);
           /* $.ajax({
              method: "POST",
              url: '/cart/update.js',
              data: data_array,
              dataType: 'json',
              success: function(data){
                $.ajax({
                  type: 'GET',
                  url: '/cart.js',
                  dataType: 'json',
                  success: function(cartdata){
					//console.log(data);
                  }
                });
              }
            });*/
            
            var html1 = data.sheet_name; 
            var html2 =  data.free_offprints;
            var html3 =  data.author_email;
            var html4 =  data.journal_title;
            var html5 =  data.journal_id;
            var html6 =  data.article_id;
            var html7 =  data.article_DOI;
            var html8 =  data.journal_title;
            var html9 =  jb_key;
            var html10 = data.event_year +"-"+ data.event_month +"-"+ data.event_day;

            let manage_cart_button = (th) => {
              var varaintName = $(th).val();
              
              if($(th).val() == 0 && data.free_offprints == 0){                
                $('.product-single_'+varaintName+'').hide();
                //$(".product-single__add").hide();
                jQuery('.product-single_25').click();
              }else{
                $('.product-single_'+varaintName+'').show();
                $(".product-single__add").show();
              }
            }

            // hide cart button if select 0 and get free offprints 0
            manage_cart_button($(".product-single__swatch__input"));

            $(document).on("change load", ".product-single__swatch__input", function(){
              manage_cart_button(this);
            });
            
            //hide loader
            $(".spinner").fadeOut("slow");

          }else{

            show_alert();
          }

          $("#journal_details").html(html);
          $("#properties_data #job_sheet").val(html1);
          $("#properties_data #free_offprints").val(html2);
          $("#properties_data #url_email").val(html3);
          $("#properties_data #journal_title").val(html4);
          $("#properties_data #journal_id").val(html5);
          $("#properties_data #article_id").val(html6);
          $("#properties_data #article_DOI").val(html7);
          $("#properties_data #note").val(html8);
          $("#properties_data #jb_key").val(html9);
          $("#properties_data #event_date").val(html10);
        }

      });
    }else{
      // URL has no key, show alert
      show_alert();
    }
        
  }

  //   let mutation = `
  // query {
  // productByHandle(handle: "reprints") {
  // title
  // id
  // metafields(first: 5, namespace: "test") {
  // edges {
  // node {
  // key
  // value
  // }
  // }
  // }
  // }
  // }
  // `;

  //   let settings = {
  //     'async': true,
  //     'crossDomain': true,
  //     'url': 'https://springer-nature-author-services.myshopify.com/api/2020-10/graphql.json',
  //     'method': 'POST',
  //     'headers': {
  //       'X-Shopify-Storefront-Access-Token': '3ca142d8195cbc9e4cdd177d699e15f9',
  //       'Content-Type': 'application/graphql',
  //     },
  //     'data': mutation
  //   };
  // Get checkout URL from shopify
  //   $.ajax(settings).done(function (response) {
  //     console.log(response);
  //   });
  
  if(url_string.includes("products/poster")){
    if(jb_key !== null){
      $(".product-single__qty-input .js-qty button").css('display','none');
      $(".product-single__qty-input .js-qty .js-qty__num").css('width','90px');
    }
  }
  if(url_string.includes("products/nature-poster")){
    if(jb_key !== null){
      $(".product-single__qty-input .js-qty button").css('display','none');
      $(".product-single__qty-input .js-qty .js-qty__num").css('width','90px');
    }
  }
  
})



function set_href(variant){
    
 // console.log(variant);
  //$("href").prop("href", "/cart/"+variant.id+":1?checkout[shipping_address][city]=thisismyhometown")
    
}


document.addEventListener('update', e => {

  console.log("text",e.detail.variant);

});

// @rajendra: MEC-1412 Scite product, User can only buy the Scite product with one package restrction code start here.
$(window).on("load", function() {
  
  let url_string = window.location.href;
  if(url_string.includes("products/scite")){
    setTimeout(function() {
      $('.custom-addtocart-btn').fadeIn();
      $('.custom-addtocart-btn').css("pointer-events", "unset");
    }, 1200);
    $.getJSON('/cart.js', function(cart) {
      // now have access to Shopify cart object
      $.each(cart.items, function(key, data){
        var pro_id = data.product_id;
        if (pro_id == 7651533226135)
        {
          $('.dis-pro-'+ pro_id).attr("disabled", true);
          $('.hide-custom-swatch-'+ pro_id).attr("disabled", true);
          $('.js-qty__adjust--minus').attr("disabled", true);
          $('.js-qty__adjust--plus').attr("disabled", true);
          $('.js-qty__num').attr("disabled", true);
          $('.cursor-not-allow-'+ pro_id).css("cursor", "not-allowed");
          $('.dis-pro-text-'+ pro_id).delay(800).fadeIn();
        }
      });

    });
  }

  // END Scite product restriction code.

  /* 
    Description: code to show the calculation after selecting a variant and to remove text content from product variants
    Author: Atul Gavali
    Date: 27-06-24
  */
  if(url_string.includes("products/reprints") || url_string.includes("products/nature-reprints")){
	$(document).ready(function(){
		setTimeout(function(){
			$('.product-single_Paid.offprints\\:100').trigger('click');
		},1200);
	});
    /* script to show the calculation after selecting a variant */
    $('body').on('change','.js-product-single-swatch',function(){
      var checkedVariant = parseInt($('.product-single__swatch__input:checked').val().replace('Paid offprints:', ''));
      var price = parseInt($('.product-single__price-number .money').text().replace('$','').replace(',',''));
      var perCopyPrice = price / checkedVariant;
      if(checkedVariant == 0) {
        $('.product-price--unit').html('');
      } else {
        $('.product-price--unit').html(' ($'+perCopyPrice.toFixed(2)+' per copy)');
      }
    });
    
    /*to remove text content from product variants*/
    $('.js-product-single-swatch .product-single__swatch__label').each(function () {
        let text = $(this).text();
        text = text.replace('Paid offprints:', '');
        
        $(this).text(text);
    })
  }


  /* ADA compliance fixes implemented */
  document.querySelectorAll(".product-single__swatch__item.radio").forEach((div,index) => {
    const radioInput = div.querySelector('input[type="radio"]');
        if (radioInput) {
         radioInput.setAttribute("aria-checked",index==0?"true":"false");
         div.setAttribute("aria-checked",index==0?"true":"false");
    }
    const handleSelection = () => {
        document.querySelectorAll(".product-single__swatch__item.radio").forEach((div,index) => {
        const radioInput = div.querySelector('input[type="radio"]');
        if (radioInput) {
         div.setAttribute("aria-checked","false"); 
         radioInput.setAttribute("aria-checked","false");
        }});
        const radio = div.querySelector('input[type="radio"]');
        if (radio && radio.type === "radio") {
          radio.click();
          radio.setAttribute('aria-checked', 'true');
          div.setAttribute('aria-checked', 'true');
        }
   }
  div.addEventListener("keydown", function(event) {
      if (event.key === "Enter") {  
        handleSelection()
      }
      });
  div.addEventListener("click", handleSelection);  
  });

  
    const swatchItems = Array.from(document.querySelectorAll('.product-single__swatch__item.radio'));
    //console.log("arrow",swatchItems);
    swatchItems.forEach((item, index) => {
      item.addEventListener('keydown', function (e) {
        let newIndex;
        if (e.key === 'ArrowRight') {
          console.log("arrow");
          e.preventDefault();
          newIndex = (index + 1) % swatchItems.length;
          swatchItems[newIndex].focus();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          newIndex = (index - 1 + swatchItems.length) % swatchItems.length;
          swatchItems[newIndex].focus();
        }
      });
    });

   
   $(document).on('mfpOpen', function() {
      const $closeBtn = $('.mfp-close');
      const $menuDraw = $('.js-menu-draw');
      if ($closeBtn.length && $menuDraw.length) {
        $closeBtn.detach();
        $menuDraw.prepend($closeBtn);
      }
   });



/* EOC */

  

/* ADA compliance fixes implemented by Arpit */
    const searchInput = document.querySelector('#search-box');
    const formFieldTitle = document.querySelector('.form-field-title');
  
   
        if (searchInput?.value?.trim() !== "") {
            formFieldTitle?.classList.add('focus-input');
        } else {
            formFieldTitle?.classList.remove('focus-input');
        }

       searchInput?.addEventListener('input', () => {
        if (searchInput?.value?.trim() !== "") {
            formFieldTitle?.classList.add('focus-input');
        } else {
            formFieldTitle?.classList.remove('focus-input');
        }
    });

/* ADA compliance fixes implemented by Arpit */  

});